/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PermissionSearchOrderBy } from './PermissionSearchOrderBy';
import {
    PermissionSearchOrderByFromJSON,
    PermissionSearchOrderByFromJSONTyped,
    PermissionSearchOrderByToJSON,
    PermissionSearchOrderByToJSONTyped,
} from './PermissionSearchOrderBy';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';

/**
 * 
 * @export
 * @interface PermissionSearchOrderByPaginationQuery
 */
export interface PermissionSearchOrderByPaginationQuery {
    /**
     * 
     * @type {any}
     * @memberof PermissionSearchOrderByPaginationQuery
     */
    pageNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionSearchOrderByPaginationQuery
     */
    pageSize?: any | null;
    /**
     * 
     * @type {SortOrder}
     * @memberof PermissionSearchOrderByPaginationQuery
     */
    sortOrder?: SortOrder;
    /**
     * 
     * @type {PermissionSearchOrderBy}
     * @memberof PermissionSearchOrderByPaginationQuery
     */
    orderField?: PermissionSearchOrderBy;
}



/**
 * Check if a given object implements the PermissionSearchOrderByPaginationQuery interface.
 */
export function instanceOfPermissionSearchOrderByPaginationQuery(value: object): value is PermissionSearchOrderByPaginationQuery {
    return true;
}

export function PermissionSearchOrderByPaginationQueryFromJSON(json: any): PermissionSearchOrderByPaginationQuery {
    return PermissionSearchOrderByPaginationQueryFromJSONTyped(json, false);
}

export function PermissionSearchOrderByPaginationQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionSearchOrderByPaginationQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] === undefined ? undefined : json['pageNumber'] === null ? null : json['pageNumber'],
        'pageSize': json['pageSize'] === undefined ? undefined : json['pageSize'] === null ? null : json['pageSize'],
        'sortOrder': json['sortOrder'] == null ? undefined : SortOrderFromJSON(json['sortOrder']),
        'orderField': json['orderField'] == null ? undefined : PermissionSearchOrderByFromJSON(json['orderField']),
    };
}

export function PermissionSearchOrderByPaginationQueryToJSON(json: any): PermissionSearchOrderByPaginationQuery {
    return PermissionSearchOrderByPaginationQueryToJSONTyped(json, false);
}

export function PermissionSearchOrderByPaginationQueryToJSONTyped(value?: PermissionSearchOrderByPaginationQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sortOrder': SortOrderToJSON(value['sortOrder']),
        'orderField': PermissionSearchOrderByToJSON(value['orderField']),
    };
}

